import { render, staticRenderFns } from "./ConfigurationSalesWasteReasons.vue?vue&type=template&id=76941381&"
import script from "./ConfigurationSalesWasteReasons.vue?vue&type=script&lang=js&"
export * from "./ConfigurationSalesWasteReasons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports